/**
 * Build a stable identity from meaningful WS-message fields so two
 * messages received in the same millisecond aren't collapsed as
 * duplicates. [WS_DEDUP_COMPOSITE_KEY] — 17 fields.
 */
export const generateMessageHash = (message: any): string => {
  const identity = [
    message?.timestamp ?? "",
    message?.design_id ?? "",
    message?.design_type ?? "",
    message?.type ?? "",
    message?.status ?? "",
    message?.progress ?? "",
    message?.train_id ?? message?.training_id ?? "",
    message?.session_id ?? "",
    message?.img_count ?? "",
    Array.isArray(message?.data) ? message.data.length : "",
    message?.message ?? "",
    message?.error ?? "",
    message?.chunk_index ?? "",
    // Studio edit frames carry none of the fields above that tell two results apart (no design_id, no
    // BE timestamp — the client stamps its own millisecond clock on receive). Without these four, two
    // completions landing in the same millisecond (a replay burst on reconnect, two pose results)
    // hashed identically and the second was dropped.
    message?.project_id ?? "",
    message?.product_id ?? "",
    message?.edit_type ?? "",
    message?.image_url ?? "",
  ].join("|");

  return `msg_${identity}`;
};
